import {
    GET_SEARCH_VALUE
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SEARCH_VALUE:
            return {
                ...state,
                SUBMIT_loading: false,
                searchValue: action.searchValue,
            }
        default:
            return state
    }
}